import styled from 'styled-components';
import icon from '../../assets/images/download-button.svg';

export const SignatureSuccess = styled.div`
	display: flex;
	flex-direction: column;
	padding: 32px 16px 16px;
	flex: 1;
`;

SignatureSuccess.Center = styled.div`
	display: flex;
	justify-content: center;
`;

SignatureSuccess.ContainerEvenly = styled.div`
	display: flex;
	justify-content: center;
	position: relative;
	@media only screen and (max-width: 600px) {
		justify-content: space-evenly;
	}
`;

SignatureSuccess.Container = styled.div`
	margin-bottom: 2rem;
	display: row;
	justify-content: center;
`;

SignatureSuccess.ContainerCenter = styled.div`
	margin-bottom: 16px;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

SignatureSuccess.Image = styled.img`
	width: 162px;
	height: 28px;
`;

SignatureSuccess.ImageSuccess = styled.img`
	width: 64px;
	height: 64px;
`;

SignatureSuccess.Title = styled.h1`
	font-weight: 500;
	font-size: 28px;
	text-align: center;
	color: #26282A;
	line-height: 28px;
`;

SignatureSuccess.Text = styled.p`
	font-weight: 400;
	font-size: 18px;
	text-align: center;
	color: #4E5255;
	line-height: 20px;
`;

SignatureSuccess.UserName = styled.p`
	word-break: break-all;
	font-weight: 500;
	font-size: 18px;
	text-align: center;
	color: #26282A;
	line-height: 20px;
	margin-bottom: 8px;
`;

SignatureSuccess.Cpf = styled.p`
	font-weight: 400;
	font-size: 16px;
	color: #4E5255;
	line-height: 20px;
	text-align: center;
`;

SignatureSuccess.VoidDiv = styled.div`
	height: 13rem;
`;

SignatureSuccess.Footer = styled.div`
	display: flex;
	height: 100%;
	flex: 1;
	flex-direction: column;
	justify-content: flex-end;
`;

SignatureSuccess.Button = styled.button`
	color: #26282A;
	border: 1px solid #D9E1E8;
	border-radius: 8px;
	height: 50px;
	display: flex;
	width: 100%;
	justify-content: center;
`;

SignatureSuccess.SignatureBox = styled.img`
	width: 180px;
	margin: 0 auto;
	height: 80px;
`;

SignatureSuccess.IconSvg = styled.span`
	background: url(${icon}) no-repeat top left;
	cursor: pointer;
	display: inline-block;
	height: 52px;
	width: 40px;
	position: relative;
	left: 12px;
`;

SignatureSuccess.ButtonText = styled.p`
	font-size: 16px;
`;

SignatureSuccess.AnchorProps = styled.a`
	width: 100%;
	margin: 16px 0;
`;
